export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold mb-4">Gary Wilson</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Author, Speaker, and Thoughtful Observer of Life's Decisions
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-colors">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 border border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-colors">
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide mb-4">CONTACT</h4>
            <div className="space-y-3 text-sm">
              <div>
                <p className="text-gray-400 mb-1">Email</p>
                <a href="mailto:contact@garywilson.com" className="text-white hover:text-amber-400 transition-colors">
                  contact@garywilson.com
                </a>
              </div>
              <div>
                <p className="text-gray-400 mb-1">Phone</p>
                <a href="tel:+15551234567" className="text-white hover:text-amber-400 transition-colors">
                  (555) 123-4567
                </a>
              </div>
              <div>
                <p className="text-gray-400 mb-1">Mailing Address</p>
                <p className="text-white">
                  New Jersey, USA
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex justify-center md:justify-end">
            <div className="rounded-xl overflow-hidden shadow-lg w-48 h-64">
              <img 
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/8766ce79d993580eb8f66710c4ab0aaa.png" 
                alt="Gary Wilson"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Gary Wilson. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-white transition-colors whitespace-nowrap">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors whitespace-nowrap">Terms of Service</a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors whitespace-nowrap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}